import React, { useEffect, useState } from 'react';
import { supabase } from '../Servicios/supabaseClient';
import { useAuth } from '../Context/AuthContext';
import Swal from 'sweetalert2';

export default function InvoicesList() {
    const { user } = useAuth();
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user) return;
        fetchInvoices();

        // Suscripción Real-time: Si n8n termina una factura, la lista se actualiza sola
        const channel = supabase
            .channel('public:invoices')
            .on('postgres_changes',
                { event: '*', schema: 'public', table: 'invoices', filter: `user_id=eq.${user.id}` },
                (payload) => {
                    fetchInvoices(); // Recargar lista si hay cambios
                }
            )
            .subscribe();

        return () => {
            supabase.removeChannel(channel);
        };
    }, [user]);

    const fetchInvoices = async () => {
        try {
            const { data, error } = await supabase
                .from('invoices')
                .select('*')
                .eq('user_id', user.id)
                .order('created_at', { ascending: false });

            if (error) throw error;
            setInvoices(data);
        } catch (error) {
            console.error('Error cargando facturas:', error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDownload = async (path) => {
        if (!path) return Swal.fire('Atención', 'El archivo no está disponible aún.', 'warning');

        try {
            const cleanPath = path.replace(/^facturas\//, '');
            // Pedimos la URL firmada (válida por 60 segundos)
            const { data, error } = await supabase
                .storage
                .from('facturas') // <--- Asegúrate que coincida con el nombre de tu bucket
                .createSignedUrl(cleanPath, 60);

            if (error) throw error;

            // Abrimos el PDF en una pestaña nueva
            window.open(data.signedUrl, '_blank');

        } catch (error) {
            console.error('Error descargando:', error.message);
            Swal.fire('Error', 'No se pudo descargar la factura. Verifica tus permisos.', 'error');
        }
    };

    if (loading) return <div>Cargando facturas...</div>;

    return (
        <div className="tableWrap">
            {invoices.length === 0 ? (
                <p style={{ padding: '1rem', color: '#888' }}>No tienes facturas generadas aún.</p>
            ) : (
                <table className="table">
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Concepto</th>
                            <th>Monto</th>
                            <th>Estado</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices.map((inv) => (
                            <tr key={inv.id}>
                                <td>{new Date(inv.created_at).toLocaleDateString()}</td>
                                <td>{inv.concepto || '-'}</td>
                                <td>${inv.monto}</td>
                                <td>
                                    <span className={`pill ${inv.status === 'completada' ? 'pillOk' : inv.status === 'error' ? 'pillErr' : 'pillWarn'}`}>
                                        {inv.status}
                                    </span>
                                </td>
                                <td>
                                    {inv.status === 'completada' ? (
                                        <button
                                            className="btnGhost"
                                            onClick={() => handleDownload(inv.file_path)}
                                            style={{ padding: '5px 10px', fontSize: '0.8rem' }}
                                        >
                                            Descargar PDF
                                        </button>
                                    ) : (
                                        <span style={{ fontSize: '0.8rem', color: '#888' }}>Generando...</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
